import React, { Component } from "react";
import styled from "styled-components";
import { Redirect } from 'react-router-dom';

// Utils //
import history from "utils/history";

// HOC //
import withChat from "hoc/withChat";

// Components //
import CodeEditor from "components/CodeEditor";
import Text from "components/Text";
import Response from 'components/Response';
import StepHeader from 'components/StepHeader';
import StepFooter from 'components/StepFooter';
import SuccessMessage from 'components/SuccessMessage';
import ErrorMessage from 'components/ErrorMessage';

const Root = styled.div`
  padding-bottom: 24px;
`;

const Header = styled(StepHeader)`
  margin-bottom: 40px;
`;

class Step6 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      event: null,
      hasRan: false,
      modalIsOpen: false,
      value: `channel.on("message.new", event => {
  logEvent(event);
});

await channel.sendMessage({
  text: "What is the medieval equivalent of tabs vs spaces?",
});`
    };
  }

  run = async () => {
    const { channel, match, setLoading, setError, setStepComplete } = this.props; // eslint-disable-line no-unused-vars
    const { value } = this.state;
    const logEvent = (e) => this.logEvent(e); // eslint-disable-line no-unused-vars
    try {
      await setLoading(true);
      await eval(`(async () => {${value}})();`); // eslint-disable-line no-eval
      await setStepComplete(5);
      await setLoading(false);

      this.setState({ hasRan: true });
    } catch (err) {
      await setLoading(false);
      setError(err.message);
    }
  };

  logEvent = event => {
    this.setState({ event });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  handleCodeChange = value => {
    this.setState({
      value
    });
  };

  handlePrevClick = () => history.push(`/step-5`)

  handleNextClick = () => history.push(`/step-7`);

  render() {
    const { client, channel, completedSteps, error, loading } = this.props;
    const { event, hasRan, value } = this.state;
    const isComplete = completedSteps.includes(5);

    if (!client || !channel) {
      return <Redirect to="/step-1" />
    }

    return (
      <Root>
        <Header
          step={6}
          title="State & Listening to Events"
        >
          <Text size={18}>
            So far we've been relying on the pre-made UI components. If you're building your own UI components you'll want to listen to the Chat events directly. Have a look at how to intercept the <b>message.new</b> event, and send a new message:
          </Text>
        </Header>
        <CodeEditor
          onChange={this.handleCodeChange}
          onRunClick={this.run}
          value={value}
          runLabel="Start Listening"
        />
        {hasRan && (
          <SuccessMessage
            style={{marginTop: 16}}
            text="Listener Created."
          />
        )}
        {event && <Response json={event} />}
        <StepFooter
          disableNext={!isComplete && !hasRan}
          loading={loading}
          onPrevClick={this.handlePrevClick}
          onNextClick={this.handleNextClick}
        />
        {error && <ErrorMessage
          error={error}
        />}
      </Root>
    );
  }
}
export default withChat(Step6);
